export const environment = {
  production: true,
  environment: 'production',
  apiUrl: 'https://speero.net/api',
  cfAccessClientSecret: 'cfAccessClientSecret'
};